export default class Middleware {
  private _atoms: Array<(data?: any) => Promise<void>> = [];
  
  public register(func: (data?: any) => Promise<void>) {
    this._atoms.push(func);
  }

  public async onChangeEmit(data?: any) {
    return Promise.all(
      this._atoms.map((func) => func(data))
    );
  }
}